import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import Logo from "./Logo";
import { scrollToSection } from "./Nav";

export default function Footer() {
  return (
    <footer className="border-t border-sand/10 bg-basalt" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-16 md:grid-cols-3 lg:px-10">
        <div>
          <Logo />
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-mist">
            Turning non-compliance into absolute institutional excellence for ICF &amp; IDD
            facilities — guaranteed, or your money back.
          </p>
        </div>
        <div>
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">Navigate</span>
          <div className="mt-5 flex flex-col gap-3">
            {[
              { label: "Services", href: "#services" },
              { label: "Track Record", href: "#track-record" },
              { label: "Guarantee", href: "#guarantee" },
              { label: "Success Stories", href: "#success-stories" },
              { label: "Leadership", href: "#leadership" },
              { label: "Emergency Intake", href: "#intake" },
            ].map((l) => (
              <button
                key={l.href}
                onClick={() => scrollToSection(l.href)}
                className="w-fit text-sm text-mist transition-colors duration-300 hover:text-ochre"
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">Contact</span>
          <div className="mt-5 flex flex-col gap-3 text-sm text-mist">
            <a href="tel:+18084913395" className="flex items-center gap-3 transition-colors duration-300 hover:text-ochre" data-testid="footer-phone-james">
              <Phone size={14} className="text-ochre" /> James Bordenave — 808-491-3395
            </a>
            <a href="tel:+18083154667" className="flex items-center gap-3 transition-colors duration-300 hover:text-ochre" data-testid="footer-phone-maria">
              <Phone size={14} className="text-ochre" /> Maria Lopez — 808-315-4667
            </a>
            <a href="mailto:jamesbordenave43@gmail.com" className="flex items-center gap-3 transition-colors duration-300 hover:text-ochre" data-testid="footer-email">
              <Mail size={14} className="text-ochre" /> jamesbordenave43@gmail.com
            </a>
            <a href="mailto:bordenavebelle@gmail.com" className="flex items-center gap-3 transition-colors duration-300 hover:text-ochre" data-testid="footer-email-maria">
              <Mail size={14} className="text-ochre" /> bordenavebelle@gmail.com
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-sand/10">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-6 py-6 sm:flex-row sm:items-center lg:px-10">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-smoke">
            © {new Date().getFullYear()} Hale Pono Community Support Services LLC
          </span>
          <Link
            to="/admin/login"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-smoke transition-colors duration-300 hover:text-ochre"
            data-testid="admin-login-link"
          >
            Admin Portal
          </Link>
        </div>
      </div>
    </footer>
  );
}
